import React, { useState } from 'react';
import Header from "../header/header";
import Menu from "../menu/menu";
import Cards from "../cards/cards";
import { useFindMenuId } from "../menu/utils";
import style from "./style/style.module.scss";
import file2 from "../../assets/dzernark.jpg";
import file1 from "../../assets/tghg.png";

const Information = () => {
    const [showInfoText, setShowInfoText] = useState(true);

    return (
        <div className={style.box}>
            <Header />
            <Menu />

            {showInfoText && (
                <div className={style.infoText}>
                    {/*<div className={style.pdfViewer}>*/}
                    {/*    <iframe src={file} title="PDF Viewer" />*/}
                    {/*</div>*/}
                    <div className={style.images}>
                        <img src={file1} alt="ԹԳՀԳ "/>
                        <img src={file2} alt="ԹԳՀԳ ձեռնարկ"/>

                    </div>

                    <h3>ԹԳՀԳ առարկայի բոլոր լաբորատոր աշխատանքները վերոնշյալ ձեռնարկից են </h3>
                    <p />
                </div>
            )}

            <Cards item_id={useFindMenuId()} onCardClick={() => setShowInfoText(false)} />
        </div>
    );
};

export default Information;
